import React, { useEffect, useMemo, useState } from 'react';
import {
  ButtonLink,
  CarouselHeaderWrapper,
  IconButton,
  SetNameDiv,
  TypologyListDiv
} from './styled';
import CarouselContent from './CarouselContent';
import { Select, Space, Tooltip } from 'antd';
import {
  DownOutlined,
  FilterOutlined,
  MenuOutlined,
  UpOutlined
} from '@ant-design/icons';
import StatusContainer from './StatusContainer';
import style from './styles.scss';

const AllSetsModal = ({ typologySets, headerLabel }) => {
  const [openIndex, setOpenIndex] = useState([]);
  const [viewType, setViewType] = useState('list');
  const [selectedSet, setSelectedSet] = useState(undefined);

  useEffect(() => {
    setOpenIndex(typologySets.map((_, i) => i));
  }, [typologySets]);

  const handleOpenAccordion = (index) => {
    setOpenIndex((prev) =>
      prev.indexOf(index) > -1
        ? prev.filter((p) => p !== index)
        : [...prev, index]
    );
  };

  const filterOption = useMemo(
    () =>
      typologySets.map((typology, i) => ({
        label: `Set - ${typology.combinationName}`,
        value: typology.combinationId.toString()
      })),
    [typologySets]
  );

  const handleFilterChange = (value) => {
    if (value === 'filter') {
      setSelectedSet(filterOption?.[0].value);
    } else {
      setSelectedSet(undefined);
    }
    setViewType(value);
  };

  const handleChange = (value) => {
    setSelectedSet(value);
  };

  const allTypo = typologySets?.map((t) => t.typologies).flat() || [];

  const typoCount = allTypo.filter(
    (f, i) => allTypo.findIndex((s) => s.id == f.id) === i
  ).length;

  return (
    <div>
      <CarouselHeaderWrapper direction="horizontal">
        <Space direction="vertical" size={0}>
          <span style={{ fontWeight: 'bold' }}>{headerLabel}</span>
          <span style={{ fontWeight: 'bold' }}>
            View all Sets and linked typologies
          </span>
        </Space>
        <Space direction="vertical" align="end" size={0}>
          <span>Viewing Mode</span>
          <Space>
            <Tooltip placement="bottom" title={`filter`}>
              <IconButton
                className={viewType === 'list' ? 'inactive' : ''}
                icon={<FilterOutlined />}
                onClick={() => handleFilterChange('filter')}
              />
            </Tooltip>
            <Tooltip placement="bottom" title={`list`}>
              <IconButton
                className={viewType === 'filter' ? 'inactive' : ''}
                icon={<MenuOutlined />}
                onClick={() => handleFilterChange('list')}
              />
            </Tooltip>
          </Space>
        </Space>
      </CarouselHeaderWrapper>
      <CarouselHeaderWrapper direction="horizontal" size={0}>
        <StatusContainer typoNo={typoCount} sets={typologySets.length} />
        <Space size={0}>
          {viewType === 'filter' && (
            <Select
              style={{ width: '470px', marginTop: '55px' }}
              placeholder="Please select"
              onChange={handleChange}
              options={filterOption}
              defaultValue={selectedSet}
            />
          )}
        </Space>
      </CarouselHeaderWrapper>
      <TypologyListDiv align="start">
        {typologySets
          .filter((typo) => {
            if (selectedSet) {
              return typo.combinationId == selectedSet;
            } else {
              return true;
            }
          })
          .map((typology, index) => (
            <>
              <SetNameDiv>
                <Space direction="horizontal">
                  <ButtonLink
                    type="link"
                    icon={
                      openIndex.indexOf(index) > -1 ? (
                        <UpOutlined />
                      ) : (
                        <DownOutlined />
                      )
                    }
                    onClick={() => handleOpenAccordion(index)}
                  />
                  <span>Set - {typology.combinationName}</span>
                </Space>
                <span>
                  Total {typology.typologies.length}{' '}
                  <span className={style.fontBlue}>
                    typologies in this config
                  </span>
                </span>
              </SetNameDiv>
              {openIndex.indexOf(index) > -1 && (
                <CarouselContent key={selectedSet} selectedSet={typology} />
              )}
            </>
          ))}
      </TypologyListDiv>
    </div>
  );
};

export default AllSetsModal;
